import { useSelector } from "react-redux";

import { useEffect } from "react";
import Disclaimer from "../disclaimer/Disclaimer";
import Banner from "../banner/Banner";
import DownLoadApps from "../downloadApps/DownloadApps";
import Html from "../HTML/Html";
import Quote from "../Quote/Quote";
import VideoConference from "../VideoConference/VideoConference";

export default function SelectFeature({ TemplateType }) {
  const userFeature = useSelector((state) => state.userFeatures);

  let temps = null;

  useEffect(() => {}, [userFeature]);

  switch (TemplateType) {
    case "Banner":
      temps = <Banner />;
      break;

    case "Disclaimer":
      temps = <Disclaimer />;
      break;

    case "DownloadApps":
      temps = <DownLoadApps />;
      break;

    case "Html":
      temps = <Html />;
      break;

    case "Quote":
      temps = <Quote />;
      break;

    case "VideoConference":
      temps = <VideoConference />;
      break;

    default:
      temps = "Sorry ,This Feature is not available at this moment";
  }

  return temps;
}
